import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import InputAdornment from '@mui/material/InputAdornment'
import FormHelperText from '@mui/material/FormHelperText'
import IconButton from '@mui/material/IconButton'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

const CustomTextField = (props) => {
  const { error, errorText, loginError, loginHelperText, loginErrorSx, loginErrorHelperSx, loginHelperSx } = props
  const { StartIcon, EndIcon } = props
  const { currentValue, setCurrentValue } = props
  const { label, multiline, minRows, maxRows } = props
  const { variant, required, type, size, color, step, min, max } = props
  const { field_key } = props
  const { sx, outlinedInputSx, withoutLabel } = props
  const { disabled } = props
  const { index } = props

  const [showPassword, setShowPassword] = useState(false)
  const [inputType, setInputType] = useState('text')

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show)
  }
  
  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }
  
  const passwordEndAdornment = (
    <InputAdornment position='end'>
      <IconButton
        onClick={handleClickShowPassword}
        onMouseDown={handleMouseDownPassword}
        edge='end'
        sx={{ color: (sx && sx.color) ? sx.color : undefined }}
      >
        { showPassword ? <VisibilityOff /> : <Visibility /> }
      </IconButton>
    </InputAdornment>
  )

  const startAdornment = StartIcon ?
  <InputAdornment position='start'>
    {StartIcon}
  </InputAdornment> : ''

  const endAdornment = EndIcon ?
  <InputAdornment position='end'>
    {EndIcon}
  </InputAdornment> : ''

  const onChange = (event) => {
    setCurrentValue(event, field_key, index)
  }

  const labelStyle = sx ? {
    color: sx.color ? sx.color : undefined,
    background: sx.background ? sx.background : 'none',
    padding: sx.background ? '1px 5px' : '0px',
  } : {}

  useEffect(() => {
    if (type === 'password' && showPassword) {
      setInputType('text')
    } else if (type) {
      setInputType(type)
    } else {
      setInputType('text')
    }
  }, [type, showPassword])
  
  return (
    <>
      <FormControl 
        required={required} 
        error={error} 
        sx={{ width: '100%', ...sx, opacity: disabled ? 0.7 : 1 }} 
        variant={variant ? variant : 'outlined'}
      >
        {
          !withoutLabel &&
          <InputLabel size={size ? size : 'medium'}>
            <Box component='span' sx={labelStyle}>{label}</Box>
          </InputLabel>
        }

        <OutlinedInput
          size={size ? size : 'medium'}
          color={color ? color : 'primary'}
          type={inputType}
          multiline={multiline ? multiline : false}
          minRows={minRows ? minRows : 5}
          maxRows={maxRows ? maxRows : 20}
          inputProps={{
            max: max ? max : undefined, 
            min: (min || min === 0) ? min : undefined,
            step: step ? step : 1,
          }}
          value={currentValue}
          onChange={onChange}
          disabled={disabled ? disabled : false}
          startAdornment={startAdornment}
          endAdornment={ type === 'password' ? passwordEndAdornment : endAdornment }
          label={<Box sx={labelStyle}>{label}</Box>}
          sx={loginError ? loginErrorSx : outlinedInputSx}
        />

        {
          (error && !loginError) && 
          <FormHelperText>
            {errorText}
          </FormHelperText>
        }
      </FormControl>
      {
        loginError &&
        <FormHelperText sx={loginErrorHelperSx}>
          {errorText}
        </FormHelperText>
      }
      {
        loginHelperText &&
        <FormHelperText sx={loginHelperSx}>
          {loginHelperText}
        </FormHelperText>
      }
    </>
  )
}

export default CustomTextField